module.exports = __webpack_public_path__ + "img/fouthGray.d1a58a82.png";